import { NSALoginPage } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { Component } from "react";

class LoginPage extends Component
{
    override render()
    {
        return <NSALoginPage product_id={ProductUUID.NAMIRASOFT_ERP} />
    }
}

export default LoginPage;